<!-- 随州问卷调查 -->

<template>

    <div class="question">
        <div class="back">
            <van-image width="100%" :src="backImage" />
        </div>
        <div class="questionbox">

            <div class="pagesbox" v-if="indexPage == 0">
                <div class="textbox">
                    <span class="title">医保划扣授权告知书</span>
                    <span class="doc">尊敬的参保人：</span>
                    <span class="doc">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;为便于您参加“2026
                        年惠随保”项目，我们将在您确认参保后，通过医保结算系统进行保费划扣。请您仔细阅读以下内容：</span>
                    <span class="doc">1.您确认并授权保险公司及医保经办机构依据相关政策，从您的医保个人账户中划扣相应保费，用于缴纳惠民保费用；</span>
                    <span class="doc">2.划扣仅在您自愿参保并确认授权后进行，不会影响医保日常就医结算使用；</span>
                    <span class="doc">3.您所提供的个人信息仅用于参保核验、保费划扣及后续理赔服务，不会用于其他用途；</span>
                    <span class="doc">4.若您的医保账户余额不足或划扣失败，您可选择其他方式完成缴费；</span>
                    <span class="tips">点击“我已阅读并同意”即视为您已充分了解并同意以上内容。</span>
                </div>

                <div class="buttonbox">
                    <van-button type="primary" block color="#EA6A34">我已阅读并同意</van-button>
                </div>
            </div>

            <div class="pagesbox" v-if="indexPage == 1">

                <div class="formbox">
                    <div class="formtitle">
                        <span>投保信息录入</span>
                    </div>

                    <div class="forminput">
                        <van-cell title="参保地" value="请选择职工医保缴纳地" is-link />
                        <van-field v-model="username" label="姓名" placeholder="请输入参保人姓名" />
                        <van-field v-model="idcard" label="身份证号" placeholder="请输入参保人证件号" />
                        <van-field v-model="usertel" label="手机号" placeholder="请输入参保人手机号" />
                        <!-- <van-field name="radio" label="参保版本">
                            <template #input>
                                <van-radio-group v-model="version" direction="horizontal">
                                    <van-radio name="69" checked-color="#EA6A34">基础版69元</van-radio>
                                    <van-radio name="99" checked-color="#EA6A34">升级版99元</van-radio>
                                </van-radio-group>
                            </template>
</van-field> -->
                    </div>


                    <div class="formtitle">
                        <span>参保版本</span>
                    </div>

                    <div class="formoption">
                        <van-radio-group v-model="version">
                            <van-cell-group>
                                <van-cell title="基础版 69 元/年" clickable @click="version = '69'">
                                    <template #right-icon>
                                        <van-radio name="69" checked-color="#EA6A34"/>
                                    </template>
                                </van-cell>
                                <van-cell title="升级版 99 元/年" clickable @click="version = '99'">
                                    <template #right-icon>
                                        <van-radio name="99" checked-color="#EA6A34"/>
                                    </template>
                                </van-cell>
                            </van-cell-group>
                        </van-radio-group>
                    </div>

                </div>

                <div class="buttonbox">
                    <van-button type="primary" block color="#EA6A34">立即提交登记</van-button>
                </div>
            </div>

            <div class="pagesbox" v-if="indexPage == 2">

                <div class="showbox">
                    <div class="iconbox">
                        <van-image width="100" height="100" :src="iconImage" />
                    </div>

                    <div class="texticon">
                        <span class="icontitle">信息登记成功</span>
                        <span class="icondoc">请等待统一划扣，划扣成功将接收短信通知</span>
                    </div>
                </div>


                <div class="buttonbox">
                    <van-button type="primary" block color="#EA6A34">完成</van-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    components: {
    },
    data() {
        return {
            indexPage: 2, // 页面
            backImage: require('@/assets/随州惠民保/位图.png'),
            iconImage: require('@/assets/随州惠民保/登记.png'),

            //
            username: '',
            idcard: '',
            usertel: '',
            version: '69'
        }
    },
    mounted() {
        document.title = "惠随保医保划扣登记";
    },
    methods: {
    }
}
</script>

<style lang="less" scoped>
.question {
    position: absolute;
    width: 100vw;
    height: 100vh;
    // border: 1px solid red;
    display: flex;
    flex-direction: column;

    .back {
        width: 100%;

    }

    .questionbox {
        // margin: 10px;
        // border: 1px solid red;
        margin-top: -20px;
        z-index: 99;
        background-color: white;
        border-radius: 24px 24px 0px 0px;
        min-height: 100px;
        box-shadow: 0 -8px 20px rgba(0, 0, 0, 0.1);

        .pagesbox {
            margin: 20px;
            // border: 1px solid red;
            display: flex;
            flex-direction: column;

            // 页面 1
            .textbox {
                display: flex;
                flex-direction: column;

                span {
                    line-height: 35px;
                }

                .title {
                    font-size: 24px;
                    font-weight: bold;
                    // display: inline-block; 
                    // width: 100px; 
                    text-align: center;
                }

                .doc {
                    font-size: 20px;
                    color: #838383;
                }

                .tips {
                    font-size: 18px;
                    color: #EA6A34;
                }
            }

            .buttonbox {
                width: 100%;
                min-height: 50px;
                // border: 1px solid red;
                margin-top: 50px;

            }


            // 页面 2

            .formbox {
                width: 100%;
                min-height: 100px;
                // border: 1px solid red;

                .formtitle {
                    font-weight: bold;
                    font-size: 18px;
                    margin-top: 20px;

                    &::before {
                        content: "";
                        display: inline-block;
                        width: 4px;
                        height: 1em;
                        background-color: #EA6A34;
                        margin-right: 8px;
                        vertical-align: middle;
                    }
                }

                .formoption{

                }
            }



            // 页面 3

            .showbox {
                width: 100%;
                min-height: 200px;
                // border: 1px solid red;
                display: flex;
                flex-direction: column;
                align-items: center;
                margin-top: 50px;

                .texticon {
                    display: flex;
                    flex-direction: column;
                    align-items: center;

                    .icontitle {
                        font-size: 20px;
                        font-weight: bold;
                    }

                    .icondoc {
                        font-size: 16px;
                        color: #838383;
                    }
                }
            }
        }
    }
}
</style>